import { type XYChartState } from '../types/state.js';

export function reduceZoomDomain(
  domain: XYChartState['currentDomain'],
  zoomInEnabled: boolean,
  zoomOutEnabled: boolean,
) {
  return (prev: XYChartState): XYChartState => ({
    ...prev,
    currentDomain: domain,
    highlightedSeriesId: undefined,
    zoom: {
      ...prev.zoom,
      zoomInEnabled,
      zoomOutEnabled,
    },
    select: undefined,
  });
}
